<template>
  <nk-page :commercialAccess="['Sale', 'Warehouse']">
    <div class="h-100 d-flex flex-column">
      <div class="nk-card" style="height: 380px">
        <div style="height:100%">
          <nk-table v-model="selectedRow" :data="pricesList" :options="componentOptions.tableOptions" :tabindex="102" ref="pricesTable"></nk-table>
        </div>
      </div>
    </div>
  </nk-page>
</template>
<script>
  import _ from 'lodash'
  import validators from '~/statics/validators.js'
  import Input from '~/components/general/nikan-input.vue'
  import $sc from '~/plugins/shortcut.collection.js'

  export default {
    name: 'product-barcode-prices',
    modal: {
      size: 'md',
      stateUID: 'product-barcode-prices',
    },
    props: {
      data: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        pricesList: [],
        componentOptions: {
          tableOptions: {
            editable: true,
            allowNewRow: true,
            searchBarEnabled: false,
            sortable: true,
            buttons: {
              addBtn: {
                options: {
                  visible: true
                }
              },
              deleteBtn: {
                options: {
                  visible: true
                }
              }
            },
            prepareNewRow: () => {
              return {
                price: '',
              }
            },
            columns: [
              {
                name: 'rowNumber',
                title: this.$t('row-number'),
                type: 'number',
                width: '50px',
                pinnable: false,
                pinned: true,
                entering: false,
                leaving: true,
              },
              {
                name: 'price',
                title: this.$t('sale.product.f.barcodePrices.price'),
                type: 'price',
                width: 'auto',
                align: 'right',
                editable: true,
                entering: true,
                leaving: true,
                view: {
                  options: {
                    type: 'price',
                  },
                },
                edit: (row, col) => {
                  return {
                    component: Input,
                    options: {
                      mode: 'price',
                    },
                  }
                },
                validators: validators('required'),
              },
            ],
          },
        },
        saveBtn: {
          title: this.$t('save'),
          shortcut: $sc.find('save'),
          icon: 'save',
          isPrimary: false,
          handle(button, page, e) {
            this.save()
          },
        },
        selectedRow: null,
      }
    },
    mounted() {
      this.pricesList = (this.data?.prices || []).map(p => {
        return {
          price: p,
        }
      })
      const title = this.data?.barcode
        ? `${this.$t('sale.product.f.barcodePrices.modalTitle')} (${this.data.barcode})`
        : this.$t('sale.product.f.barcodePrices.modalTitle')
      this.prepareWindow(title, [this.saveBtn])
    },
    methods: {
      save() {
        return this.$refs.pricesTable
          .commitChanges()
          .then((data) => {
            const validRows = data.length > 0
              ? data.filter(x => x.rowState !== 'deleted' && x.price !== '' && x.price != null)
              : []

            const prices = validRows.map(x => Number(x.price))

            const duplicates = prices.filter((item, index) => prices.indexOf(item) !== index)
            if (duplicates.length > 0) {
              this.validationToast([
                {
                  key: 'duplicatePrice',
                  error: this.$t('sale.product.f.barcodePrices.duplicatePriceError'),
                },
              ])
              return
            }

            this.resolve(prices)
          })
      },
    },
  }
</script>
<style></style>
